import { Header, Footer } from '../../components';


function Legal() {

  return (
    <>
      <Header title='aboutus' />
      <main className="flex flex-col text-primary">
        <div className="min-h-screen flex flex-col items-center justify-center bg-homeLanding bg-cover bg-no-repeat bg-left-bottom w-full overflow-x-hidden">
          <div className="mt-52 mb-40 w-full max-w-7xl px-10 m6:px-5 text-primary">
            <div className="bg-white flex flex-col items-center rounded-3xl w-full py-20 px-10 shadow-xl text-justify text-2xl m6:text-xl">
              <span className="text-5xl font-bold text-center">
                Mentions légales
              </span>
              <span className="mt-8">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default Legal;